// wwwroot/app/services/support.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SupportService {
  private http = inject(HttpClient);
  constructor() {}

  reportError(traceId: string, comment: string): Promise<void> {
    return firstValueFrom(
      this.http.post<void>('api/Support/ReportError', { traceId, comment })
    );
  }
}

//angular.module('myApp').service('SupportService', SupportService);
